import styled from "styled-components";
import colours from "styles/colours";
import { fontWeights } from "styles/fonts";

export const SwitchContainer = styled.div`
  display: flex;
  flex-direction: row;
  border: 1px solid transparent;
  align-items: flex-start;
  gap: 12px;

  &.reverse {
    flex-direction: row-reverse;
    justify-content: flex-end;
  }
`;

export const SwitchToggleLabel = styled.label`
  margin-bottom: 4px;
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  border-radius: 999px;
  cursor: pointer;
`;

export const SwitchInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
`;

export const SwitchSlider = styled.span<{ $colour: string }>`
  position: absolute;
  cursor: pointer;
  top: 50%;
  height: 24px;
  width: 44px;
  transform: translateY(-50%);
  background-color: ${({ $colour }): string =>
    $colour || colours.mediumLightGrey};
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 999px;
  box-shadow: inset 0 0 0 2px ${colours.elexonBlack}0F;

  ${SwitchInput}:focus-visible + & {
    outline: 2px solid ${colours.elexonBlack};
  }

  &:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    bottom: 50%;
    left: 2px;
    transform: translateY(50%);
    background-color: ${colours.white};
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }

  ${SwitchInput}:checked + & {
    &:before {
      -webkit-transform: translate(22px, 50%);
      -ms-transform: translate(22px, 50%);
      transform: translate(22px, 50%);
    }
  }
`;

export const SwitchLabel = styled.span`
  color: ${colours.elexonBlack};

  &.header {
    font-weight: ${fontWeights.bold};
    text-transform: uppercase;
  }
`;
